import { InMemoryCache, makeVar } from '@apollo/client';
export var cache = new InMemoryCache({
    addTypename: false,
    typePolicies: {
        Query: {
            fields: {
                currentUser: {
                    read: function () {
                        return currentUserVar();
                    },
                },
                lastAccessedOrganization: {
                    read: function () {
                        return lastAccessedOrganizationVar();
                    },
                },
                availableOrganizations: {
                    read: function () {
                        return availableOrganizationsVar();
                    },
                },
                errors: {
                    read: function () {
                        return errorsVar();
                    },
                },
                chartConstruct: {
                    read: function () {
                        return chartConstructVar();
                    },
                },
            },
        },
    },
});
/**
 * Set initial values when we create cache variables.
 */
export var currentUserVar = makeVar(null);
var storedOrg = localStorage.getItem('lastAccessedOrganization');
export var lastAccessedOrganizationVar = makeVar(storedOrg ? JSON.parse(storedOrg) : null);
export var availableOrganizationsVar = makeVar(null);
// to be typed
export var errorsVar = makeVar(null);
/*
  type ChartConstruct = {
    dimensions?: ChartDimension[],
    measures?: ChartMeasures[],
    breakdowns?: ChartBreakdown[],
  }
*/
export var chartConstructVar = makeVar(null);
